export default __webpack_public_path__ + "static/media/1.d43c5f81.png";